import { CKEditor } from "ckeditor4-react";
import { useCallback, useEffect, useRef, useState } from "react";
import Error from "../error";
import config from "./fn";
import Label from "./lable";
import "./style.css";

const Editor = ({ s, v, e, setValue, isVisible = true }) => {
  const { _id, name, disabled = false, off = false, type = "type", height = '400px'} = s;
  const editorRef = useRef(null);
  const containerRef = useRef(null);
  const isExternalUpdate = useRef(false);
  const isMounted = useRef(true); // для защиты от утечек

  const style = off ? { display: "none", visibility: "hidden" } : {};
  const cnf = { ...config, width: s.width, height, versionCheck: false };
  const [err, setErr] = useState(e);
  const [status, setStatus] = useState(false);
  const [shouldRenderEditor, setShouldRenderEditor] = useState(false);

  // Синхронизация ошибок
  useEffect(() => {
    if (!isMounted.current) return;
    setErr(e);
  }, [e]);

  // Решение проблемы с нулевыми размерами: отложенный рендер
  useEffect(() => {
    if (!isMounted.current || off || !isVisible) {
      setShouldRenderEditor(false);
      return;
    }

    const timer = setTimeout(() => {
      if (!isMounted.current) return;
      setShouldRenderEditor(true);
    }, 50); // достаточно для раскрытия табов/модалок

    return () => clearTimeout(timer);
  }, [off, isVisible]);

  // Очистка при размонтировании
  useEffect(() => {
    return () => {
      isMounted.current = false;

      // Уничтожаем редактор, если он существует
      if (editorRef.current && typeof editorRef.current.destroy === 'function') {
        try {
          editorRef.current.destroy();
        } catch (err) {
          // Игнорируем ошибки при уничтожении
        }
      }
    };
  }, []);

  // Resize window — безопасная версия
  useEffect(() => {
    let resizeTimeout;

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (!isMounted.current) return;

        const editor = editorRef.current;
        if (!editor || !editor.instanceReady) return;

        // Проверяем, что элемент всё ещё в DOM
        if (!editor.element?.$.parentElement) return;

        try {
			console.log('s', s)
          editor.resize(s.width || "100%", height || "300px");
        } catch (err) {
          // Безопасное игнорирование
        }
      }, 100);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimeout);
    };
  }, [s.width, height]);

  const cls = [
    "skin-input-base",
    "input-base",
    "input-editor",
    ...(err ? ["error"] : [])
  ].join(" ");

  const handleChange = useCallback((editor) => {
    if (isExternalUpdate.current || !isMounted.current) return;

    const data = editor.getData();
    setStatus(false);
    setErr(null);
    setValue(name, data, type);
  }, [name, setValue, type]);

  const handleFocus = () => {
    if (err && !status) setStatus(true);
  };

  const handleInstanceReady = useCallback(({ editor }) => {
    if (!isMounted.current || !containerRef.current) {
      // Если компонент уже размонтирован — уничтожаем редактор
      try { editor.destroy(); } catch (e) {}
      return;
    }

    editorRef.current = editor;
    editor.instanceReady = true;

    if (v !== undefined) {
      isExternalUpdate.current = true;
      editor.setData(v, {
        callback: () => {
          if (!isMounted.current) return;
          isExternalUpdate.current = false;
          try {
            editor.resize(s.width || "100%", height || "300px");
          } catch (e) {}
        }
      });
    }
  }, [v, s.width, height]);

  // Обработка внешних обновлений значения
  useEffect(() => {
    if (!isMounted.current || !editorRef.current || v === undefined) return;

    const currentData = editorRef.current.getData();
    if (currentData !== v) {
      isExternalUpdate.current = true;
      editorRef.current.setData(v, {
        callback: () => {
          if (isMounted.current) {
            isExternalUpdate.current = false;
          }
        }
      });
    }
  }, [v]);

  return (
    <div className={cls} style={style}>
      <Label label={s?.label} />
      <div
        className="editor"
        id={_id}
        ref={containerRef}
        onClick={handleFocus}
      >
        {shouldRenderEditor && (
          <CKEditor
            style={{
              borderRadius: "20px",
              overflow: "hidden",
              borderColor: "#f3f3f3"
            }}
            config={cnf}
            readOnly={disabled}
            onChange={({ editor }) => handleChange(editor)}
            onInstanceReady={handleInstanceReady}
          />
        )}
      </div>
      {status && <Error err={err} onClick={() => setStatus(false)} />}
    </div>
  );
};

export default Editor;